import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ReportTip } from 'shared/features/reportCard/components/reportTip';

export const ReportHeading = ({
  description,
  tipMarkdown,
  title,
}: {
  description?: string;
  tipMarkdown?: string;
  title: string;
}) => {
  return (
    <Stack direction="row" justifyContent="space-between">
      <Stack direction="column" spacing={1}>
        <Typography variant="h5">{title}</Typography>
        {description && <Typography variant="body2">{description}</Typography>}
      </Stack>
      {tipMarkdown && (
        <Stack direction="row" display="block" spacing={1}>
          <ReportTip content={tipMarkdown} title={title} />
        </Stack>
      )}
    </Stack>
  );
};
